import { ModalTypeTitle } from './../interfaces/modal-type-title'
import { ModalTypes } from './../interfaces/modal-types'

export const ModalTypeTitles: ModalTypeTitle[] = [
    { type: ModalTypes.Success, title: 'general.success' },
    { type: ModalTypes.Info, title: 'general.info' },
    { type: ModalTypes.Warning, title: 'general.warning' },
    { type: ModalTypes.Alert, title: 'general.alert' }
]